const { registerFormatType } = wp.richText;

export const registerFormats = () => {
  registerFormatType("multidots/table-row", {
    title: "Table Row",
    tagName: "span",
    className: "bodyupdate-row",
    attributes: {
      id: "id",
    },
  });

  registerFormatType("multidots/table-column", {
    title: "Table Column",
    tagName: "span",
    className: "bodyupdate-column",
    attributes: {
      id: "id",
    },
  });

  registerFormatType("multidots/table-columnalign", {
    title: "Table Column Align",
    tagName: "span",
    className: "columnalign",
    attributes: {
      id: "id",
    },
  });

  registerFormatType("multidots/table-delete-row", {
    title: "Table Delete Row",
    tagName: "span",
    className: "bodyupdate-delete-row",
    attributes: {
      id: "id",
    },
  });

  registerFormatType("multidots/table-delete-column", {
    title: "Table Delete column",
    tagName: "span",
    className: "bodyupdate-delete-column",
    attributes: {
      id: "id",
    },
  });

  registerFormatType("multidots/delete", {
    title: "Deletion",
    tagName: "del",
    className: "mdremoved",
    attributes: {
      id: "id",
    },
  });

  registerFormatType("multidots/modified", {
    title: "Modified",
    tagName: "ins",
    className: "mdmodified",
    attributes: {
      id: "id",
    },
  });

  registerFormatType("multidots/insert", {
    title: "Insertion",
    tagName: "ins",
    className: "mdadded",
    attributes: {
      id: "id",
    },
  });
};